import { createAction } from 'redux-actions';
import * as orderFormTypes from './orderFormTypes';

export const duplicateOrder = createAction(orderFormTypes.DUPLICATE_ORDER, orderId => ({ orderId }));